import React from "react";
import ReactDOM from "react-dom";
import RootComponent from "./root";

ReactDOM.render(<RootComponent />, document.querySelector("#app"));
